import { render, staticRenderFns } from "./AlarmCaseDetail.vue?vue&type=template&id=217c5b50&scoped=true&"
import script from "./AlarmCaseDetail.vue?vue&type=script&lang=js&"
export * from "./AlarmCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlarmCaseDetail.vue?vue&type=style&index=0&id=217c5b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c5b50",
  null
  
)

export default component.exports